/**
 * axiosClient is responsible for axios configuration and instance creating.
 * It is also interface for all axios methods.
 */
import axios from 'axios';
const { REACT_APP_API_URL } = process.env;

const fallbackBaseUrl = 'https://se1.lifenome.com/public-api/user-api';
const baseUrl = REACT_APP_API_URL ? REACT_APP_API_URL : fallbackBaseUrl;

// Instance containing config for all requests
// Unavailable from outside
const axiosInstance = axios.create({
  //TODO: this should be done only once after login and token fetch, include token, and keep instance somewhere
  baseURL: `${baseUrl}/`,
});

/**
 * export const setAxiosTokenInterceptor = (accessToken) => {
  axiosInstance.interceptors.request.use((config) => {
    const requestConfig = config;
    if (accessToken) {
      requestConfig.headers.common.Authorization = `Bearer ${accessToken}`;
    }
    return requestConfig;
  });
};
 */

/**
 * TODO: Improve this by storing token somewhere else
 */
const getToken = () => window.localStorage.getItem('access_token');

export const updateHeaders = () => {
  const token = getToken();

  axiosInstance.defaults.headers = {
    Authorization: `Bearer ${token}`,
  };
};

const authorization = () => {
  const token = getToken();

  if (token) {
    return `Bearer ${token}`;
  }

  return '';
};
/**
 * Returns information about
 */
const getAxiosConfig = () => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: authorization(),
    },
  };

  return token ? config : undefined;
};

const axiosGET = async (url) => {
  let result = await axiosInstance.get(url, getAxiosConfig());
  return result;
};

const axiosPUT = async (url, data) => {
  let result = await axiosInstance.put(url, data, getAxiosConfig());
  return result;
};

const axiosPOST = (url, data) => {
  return axiosInstance.post(url, data, getAxiosConfig());
};

const axiosPATCH = (url, data) => {
  return axiosInstance.patch(url, data, getAxiosConfig());
};

const axiosDELETE = (url) => {
  return axiosInstance.delete(url, getAxiosConfig());
};

export { axiosGET, axiosPUT, axiosPOST, axiosPATCH, axiosDELETE };
